<template>
  <section class="services-section">
    <v-container>
      <div class="theme-title text-center">
        <h6>Under Services</h6>
        <h2 class="text-anime-style">Complete Courier & Logistics Solutions—Fast, Reliable, Global</h2>
        <div class="title-divider">
          <span class="title-divider-separator"></span>
        </div>
      </div>

      
      <v-carousel
        cycle
    height="500"
    hide-delimiter-background
    show-arrows-on-hover
    :show-arrows="false"
      >
        <!-- Each carousel item will hold 3 cards in a row -->
        <v-carousel-item
          v-for="(chunk, index) in chunkedServices"
          :key="index"
        >
          <v-row>
            <v-col
              v-for="(service, i) in chunk"
              :key="i"
              cols="12"
              sm="6"
              md="4"
            >
              
                <div class="service-item style-2">
                <div class="service-icon mb-2">
                  <v-icon large color="white" size="15">{{ service.icon }}</v-icon>
                </div>
                <div class="service-title mb-2">
                  <h4>{{ service.title }}</h4>
                </div>
                <v-img
                  :src="service.image"
                  height="180"
                  contain
                  class="mb-3"
                /> 
                <div class="service-desc">
                  <p>{{ service.description}}</p>
            <!-- <a class="service-btn" >
              <span>Learn More</span>
              <i class="flaticon flaticon-double-chevron"></i>
            </a> -->
                </div>

</div>

            </v-col>
          </v-row>
        </v-carousel-item>
      </v-carousel>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "ServicesSlider",
  data() {
    return {
      services: [
        {
          icon: "mdi-truck-fast",
          title: "Courier",
          image: "http://devcdn.wistirna.com/assets/majestic/service01.jpg",
          description: "Fast & Secure International and Domestic Courier Service. Reliable delivery for documents and packages."
        },
        {
          icon: "mdi-home-city",
          title: "Cargo",
          image: "http://devcdn.wistirna.com/assets/majestic/service02.jpg",
          description: "Heavy Goods, Hassle-Free. Safe transportation of bulk shipments across countries, cities and states."
        },
        {
          icon: "mdi-warehouse",
          title: "International Logistics",
          image: "http://devcdn.wistirna.com/assets/majestic/service03.jpg",
          description: "Global Reach, Local Care. Door-to-door freight solutions with customs and documentation support."
        },
        {
          icon: "mdi-office-building",
          title: "Ocean Freight (FCL & LCL)",
          image: "http://devcdn.wistirna.com/assets/majestic/service04.jpg",
          description: "Sea Shipping Made Simple. Full or less-than-container loads with cost-effective, timely transit."
        },
        {
          icon: "mdi-door",
          title: "Warehousing & Clearing",
          image: "http://devcdn.wistirna.com/assets/majestic/service05.jpg",
          description: "Modern storage facilities and streamlined inventory management. Fast custom clearing services."
        },
        {
          icon: "mdi-train-car",
          title: "Supply Chain Solutions",
          image: "http://devcdn.wistirna.com/assets/majestic/service06.jpg",
          description: "End-to-End Efficient, Integrated planning and tracking to optimize your entire supply chain."
        }
      ]
    };
  },
  computed: {
    // Group services into chunks of 3 per slide
    chunkedServices() {
      const chunkSize = 3;
      return Array.from({ length: Math.ceil(this.services.length / chunkSize) }, (v, i) =>
        this.services.slice(i * chunkSize, i * chunkSize + chunkSize)
      );
    }
  }
};
</script>

<style scoped>

@import "@/assets/theme-style6c2d.css";

.service-item.style-2 {
    position: relative;
    z-index: 9;
    border: 1px solid var(--themeht-border-light-color);
    padding: 20px 30px 30px;
    margin-top: 30px;
}

</style>
